const localStorageConstants = {
  accessToken: 'access_token',
  refreshToken: 'refresh_token',
  tokenType: 'token_type'
};

export default localStorageConstants;
